// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.b-header__job-search-field .sk-input__field-icon {\n  left: 10px;\n}\n.b-header__job-search-field .sk-input__input--with-icon {\n  padding-right: 10px;\n  padding-left: 40px;\n  border-radius: 4px !important;\n}\n", ""]);
// Exports
module.exports = exports;
